import { ImageArrow } from "components/utility/images";
import React, { useState, useEffect } from "react";

const MediaCenterFacetMobile = ({ facets, field }) => {
	const facet = facets;
	const [facetState, setState] = useState(facet.state);
	const [valueToggle, setValueToggle] = useState(true);
	const [clearAllowed, setClearAllowed] = useState(false);

	useEffect(() => {
		facet.subscribe(() => {
			setState(facet.state);
		});
	}, [facet]);

	const ifChecked = () => {
		let checkboxes = document.querySelectorAll('input[name="facet"]:checked');
		checkboxes.length !== 0 ? setClearAllowed(true) : setClearAllowed(false);
	};
	return (
		<>
			<div
				className={
					"media-center-mobile-filter-item-title " + (valueToggle === true ? "show" : "hide")
				}
			>
				FILTER
			</div>
			<div
				className={
					"media-center-mobile-filter-item-tag " +
					(valueToggle === false ? "left-arrow" : "right-arrow")
				}
			>
				<span
					className="media-center-mobile-filter-item-tag-element "
					onClick={() => setValueToggle(!valueToggle)}
					role="button"
					onKeyDown={() => setValueToggle(!valueToggle)}
					tabIndex="0"
					aria-label={facetState.facetId}
				>
					{field[0].name}
				</span>

				<span
					className={
						"media-center-mobile-filter-item-tag-" +
						(clearAllowed === true ? "clear-all" : "clear-disabled") +
						" sm-visible " +
						(valueToggle === false ? "show" : "hide")
					}
					onClick={() => {
						facet.deselectAll();
						setClearAllowed(false);
					}}
					role="button"
					onKeyDown={() => {
						facet.deselectAll();
						setClearAllowed(false);
					}}
					tabIndex="0"
				>
					CLEAR ALL
				</span>
				<ImageArrow />
			</div>

			<div
				className={
					"media-center-mobile-filter-item-values " + (valueToggle === false ? "show" : "hide")
				}
			>
				{facetState.values.map((value) => (
					<div key={`${value.value}-mobile`} className="media-center-mobile-filter-item-checkbox ">
						<input
							name="facet"
							className="media-center-mobile-filter-item-checkShow"
							type="checkbox"
							checked={facet.isValueSelected(value)}
							onChange={() => {
								facet.toggleSelect(value);
								ifChecked();
							}}
							disabled={facetState.isLoading}
							aria-label={value.value}
							data-a="true"
							data-a-lbl={value.value}
							data-a-cat="Coveo"
							data-a-act={`Filter | ${field[0].name}`}
						/>
						<label>{value.value}</label>
					</div>
				))}
			</div>
		</>
	);
};

export default MediaCenterFacetMobile;
